import { send } from 'server';

export const unsubscribeUser = ({ token, duration, description, casinoName }) => send({
    ID: 35817,
    responses: [35818, 35819],
    token,
    casinoName,
    ...duration && { duration },
    ...description && { description }
});
